import './about.css'

const About = () => {
    return (
        <div className="about-container section" id='about-id'>
            <div className="title">
                <span className="hide">
                    Who We Are
                </span>
            </div>

            <div className="about-text">
                Since 2005, Carolinas Courier has been a trusted name in the courier and logistics industry, proudly serving the Carolinas and the neighboring states. With nearly two decades of experience, we’ve built a reputation for reliability, efficiency, and exceptional customer service.
                What sets us apart is our close partnerships with some of the leading names in manufacturing and retail. These collaborations have allowed us to develop tailored solutions for high-demand industries, ensuring that our clients receive seamless delivery services that keep their operations running smoothly.
                <br/>
                <br/>
                Our team is committed to excellence at every step, from the moment you place an order to the final delivery. Whether it’s same-day shipments, freight coordination, or specialized services, we bring professionalism and precision to every delivery.
                As a company rooted in the community, we’re proud to contribute to the region’s growth and success. With a fleet of modern vehicles, cutting-edge technology, and dedicated drivers, we are constantly evolving to meet the needs of businesses and individuals across the map.
                Choose us for your delivery needs and experience the difference that comes with a company that truly cares about getting the job done right. 
                <br/>
                <br/>
                We are <em>driven to deliver</em>, because your satisfaction is our top priority. 
            </div>
        </div>
    );
}
export default About;